const staticBaseUrl = (process.env.REACT_APP_STATIC_BASE_URL || '').replace(/\/$/, '');

const getStaticAssetUrl = (assetPath) => {
  if (!assetPath) {
    return assetPath;
  }

  const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
  return `${staticBaseUrl}${normalizedPath}`;
};

export default getStaticAssetUrl;
